import { CancelOutlined } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./GMIMemberSearchForm.scss";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

const defaultSearchType = "Last 8 digits of VIN";
function GMIMemberSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();
  const [last8Vin, setLast8Vin] = useState(props.last8Vin || "");
  const [policyNumber, setPolicyNumber] = useState(props.policyNumber || "");

  const [moreThanEightVin, setMoreThanEightVin] = useState(false);
  // const [odometerTooLong, setOdometerTooLong] = useState(false);
  const [vinIsTooShort, setVinIsTooShort] = useState(false);

  const [searchTypes, setSearchTypes] = useState([
    { key: "MEMBER_NUMBER", value: t("ATF.ContractSearch.DropdownOptions5") },
    { key: "LAST8_VIN", value: t("ATF.ContractSearch.DropdownOptions3") },
  ]);

  const [selectedSearchType, setSelectedSearchType] = useState("MEMBER_NUMBER");
  // const [memberLenValidation, setMemberLenValidation] = useState(false);

  useEffect(() => {
    devLog(selectedSearchType);
    setPolicyNumber(policyNumber);
    setLast8Vin(last8Vin);
  }, [selectedSearchType]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        policyNumber: policyNumber,
        last8Vin: last8Vin,
        searchType: selectedSearchType,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    // if (selectedSearchType === "MEMBER_NUMBER" && policyNumber.length < 12) {
    //   setMemberLenValidation(true);
    //   return;
    // }
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        last8Vin: last8Vin,
        policyNumber: policyNumber,
        searchType: selectedSearchType,
      });
    }
    return false;
  };

  const vinInputLength = (e) => {
    setMoreThanEightVin(false);
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      setMoreThanEightVin(true);
      devLog("Vin Length error");
    }
  };

  // const memberNumLen = (e) => {
  //   setMemberLenValidation(false);
  //   if (e.target.value.length > 12) {
  //     e.target.value = e.target.value.slice(0, -1);
  //     setMemberLenValidation(true);
  //   }
  // };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",

              justifyContent: "center",

              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key === selectedSearchType)?.value}
            </Dropdown.Toggle>

            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchType}
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedSearchType(searchType.key);
                    }}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/*Last 8 VIN*/}
          {selectedSearchType === "LAST8_VIN" && (
            <>
              <div className="group-1">
                <div className="label">{t("ATF.ContractSearch.DropdownOptions3")}:</div>
                <input
                  type="text"
                  placeholder={t("ATF.ContractSearch.DropdownOptions3")}
                  name="last8Vin"
                  className="input form-control required"
                  value={last8Vin}
                  onChange={(e) => {
                    setMoreThanEightVin(false);
                    vinInputLength(e);
                    setLast8Vin(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
              {moreThanEightVin && <Alert severity="error">{t("description.VinInputErrorMsg")}</Alert>}
            </>
          )}

          {/* Member Number */}
          {selectedSearchType === "MEMBER_NUMBER" && (
            <>
              <div className="group-1">
                <div className="label">{t("ATF.ContractSearch.DropdownOptions5")}:</div>
                <input
                  type="text"
                  // placeholder={t("ATF.ContractSearch.DropdownOptions5")}
                  // placeholder="ex: GMA123456789"
                  name="odometer"
                  className="input form-control required"
                  value={policyNumber}
                  onChange={(e) => {
                    // setMemberLenValidation(false);
                    // memberNumLen(e);
                    setPolicyNumber(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
              {/* {memberLenValidation && (
                <Alert severity="error">
                  {t("description.MemberNumberInputErrorMsg")}
                </Alert>
              )} */}
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default GMIMemberSearchForm;
